// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4o-2";
export var blackBorderOnHover = "_4o-7";
export var cell = "_4o-6";
export var cellContainer = "_4o-3";
export var checked = "_4o-8";
export var disabled = "_4o-5";
export var featuredIconCellContainer = "_4o-9";
export var featuredIconTextContainer = "_4o-b";
export var featuredIconWrapper = "_4o-a";
export var noBorder = "_4o-c";
export var orangeSelectedRow = "_ce-3";
export var overflowableText = "_4o-0";
export var overflowableTextContainer = "_4o-1";
export var row = "_4q-0";
export var rowCheckboxCell = "_4o-4";
export var selectableTable = "_ce-2";